module.exports = __webpack_public_path__ + "media/entities/37-1d0f24be.png";